export interface CmsRegistrationOrderConfirmationPlanDetailsPanel {
  registrationOrderConfirmationPlanDetailsTermsAndConditions: string;
}
